import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./fr.json";
import { withDe } from "../lib/elision";

// French only in v1 — every UI string still goes through a key here rather
// than being hardcoded, so adding a language later is a translation file,
// not a refactor.
void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr } },
  lng: "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

// `{{name, de}}` in fr.json renders "d'Antoine" or "de Léa".
i18n.services.formatter?.add("de", (value: string) => withDe(value));

export default i18n;
